export default __webpack_public_path__ + "static/media/sair.5f1b7d83.svg";